import {
  postPrematricula,
  checkAlumnoPrematricula,
  checkSolicitantePrematricula,
} from "@/api/prematriculas.api";

const state = {
  curso: null,
  cursoActual: {},
  alumnos: [],
  colegio: "",
  empresa: "",
  estadio: "",
  amigo: null,
  amigoAlt: null,
  veracidad: true,
  privacidad: true,
  localizacion: "",
  fase: 2,
};

const getters = {
  /**
   * Return prematricula
   *
   */

  getPrematricula(state) {
    return state;
  },

  /**
   * Return curso
   *
   */

  getCurso(state) {
    return state.curso;
  },

  /**
   * Return curso
   *
   */

  getCursoActual(state) {
    return state.cursoActual;
  },

  /**
   * Return languages
   *
   */

  getLanguagesForAlumno: (state) => (id) => {
    return state.alumnos.filter(function(alumno) {
      return alumno.alumno == id;
    });
  },
};

const actions = {
  /**
   * Check solicitante previous prematriculas
   *
   */

  async checkSolicitantePrematricula({ dispatch }, data) {
    try {
      const response = await checkSolicitantePrematricula(
        data.idpersona,
        data.idcurso
      );

      if (
        response.statusText == "OK" &&
        typeof response.data.length != "undefined" &&
        response.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      dispatch(
        "Errors/setError",
        { error: "CODE20", componentId: data.componentId },
        { root: true }
      );

      return false;
    }
  },

  /**
   * Check language prematricula for alumno
   *
   */

  async checkAlumnoPrematricula(
    { dispatch, commit },
    { curso, idalumno, ididioma }
  ) {
    try {
      const response = await checkAlumnoPrematricula(curso, idalumno, ididioma);

      return Promise.resolve(response);
    } catch (error) {
      console.log(error);
      console.log("handle errors");

      return Promise.reject("asdas");
    }
  },

  /**
   * Post prematricula to the API
   *
   */

  async postPrematricula({ commit, state }) {
    try {
      // Check that is not any duplicate language for each alumno
      const alumnosIdiomas = {};

      state.alumnos.forEach((a, i) => {
        if (a.alumno in alumnosIdiomas) {
          const idiomaExits = alumnosIdiomas[a.alumno].indexOf(a.idioma);

          if (idiomaExits == -1) {
            alumnosIdiomas[a.alumno].push(a.idioma);
          } else {
            state.alumnos.splice(i, 1);
          }
        } else {
          alumnosIdiomas[a.alumno] = [a.idioma];
        }
      });

      // Send the prematricula
      const response = await postPrematricula(state);

      return response;
    } catch (error) {
      console.log(error);
      console.log("handle errors");

      return false;
    }
  },

  /**
   * Clear alumnos
   *
   */

  clearAlumnos({ commit }) {
    commit("CLEAR_ALUMNOS");
  },

  /**
   * Set alumnos, idiomas objects
   * @param alumnoData Array
   *
   */

  async setAlumnosData({ commit }, alumnoData) {
    try {
      alumnoData.forEach((alumno) => {
        commit("SET_ALUMNO", alumno);
      });

      return true;
    } catch (error) {
      console.log("handle errors");

      return false;
    }
  },

  /**
   * Set alumnos, idiomas objects
   * @param year Number
   *
   */

  setCurso({ commit, rootState }) {
    commit("SET_FIELD", { curso: rootState.Localizaciones.curso.curso.id });
    commit("SET_FIELD", { cursoActual: rootState.Localizaciones.curso });
  },

  /**
   * Set persona data to the state
   * @param data object or ID
   *
   */

  setPersonaPrematricula({ commit }, data) {
    commit("SET_PERSONA", data.persona);
  },

  /**
   * Set persona data to the state
   * @param data object or ID
   *
   */

  setField({ commit }, data) {
    commit("SET_FIELD", data);
  },

  /**
   * Set persona data to the state
   * @param data object or ID
   *
   */

  removeAlumnoData({ commit }, id) {
    commit("SET_REMOVE_ALUMNO", id);
  },
};

const mutations = {
  /**
   * Add alumno to the alumnos array
   * @param data object
   *
   */

  SET_ALUMNO(state, data) {
    state.alumnos.push(data);
  },

  /**
   * Add alumno to the alumnos array
   * @param data object
   *
   */

  CLEAR_ALUMNOS(state) {
    state.alumnos = [];
  },

  /**
   * Add alumno to the alumnos array
   * @param data object or ID
   *
   */

  SET_PERSONA(state, data) {
    state.persona = data;
  },

  /**
   * Add field value to the state
   * @param data Object
   *
   */

  SET_FIELD(state, data) {
    for (const [key, value] of Object.entries(data)) {
      state[key] = value;
    }
  },

  /**
   * Remove alumno data
   * @param id Integer
   *
   */

  SET_REMOVE_ALUMNO(state, id) {
    const alumnos_filtered = state.alumnos.filter(function(alumno) {
      return alumno.alumno != id;
    });

    state.alumnos = alumnos_filtered;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
